import { Component, Input, NgZone, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { ReportFailureComponent } from '../../report-failure/report-failure.component';
import { StorageService } from '../../../../services/commons/storage.service';
import { GlobalVariablesService } from '../../../../services/global-variables.service';
import { MaintenanceService } from '../../../../services/commons/maintenance.service';
import { Incidence } from '../../../../models/Incidence';
import { IncidencesRequest } from '../../../../services/SicorService/RequestObject/IncidencesRequest';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { GlobalMethodsService } from '../../../../services/global-methods.service';
import { DefaultModalComponent } from '../../default-modal/default-modal.component';
import { NavigationService } from '../../../../services/commons/navigation.service';
import { IncidenceDetailComponent } from '../../incidence-detail/incidence-detail.component';
import { ModalService } from '../../../../services/commons/modal.service';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';
import * as moment from 'moment';
import { FileSharer } from '@byteowls/capacitor-filesharer';


@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent implements OnInit {

  public reportFailureBtn = false;
  public user: string;
  public requestParams: IncidencesRequest;
  public incidencesCompleteList: Incidence[] = [];
  public failuresList: Incidence[] = [];
  public maintenancesList: Incidence[] = [];
  public lastMaintenanceHour: string;
  public lastMaintenanceDate: string;
  // public lastIncidenceNotifiedHour: string;
  // public lastIncidenceNotifiedDate: string;
  // public lastIncidenceNotifiedCode: number;
  public isMaintenanceScheduled = false;
  public isServiceBusy = false;
  @Input('data') data: string;
  public lastRowRequested = 0;
  public scrollDepthTriggered: boolean;
  public allFailuresShown: boolean;

  constructor(private modalCtrl: ModalController,
    private zone: NgZone,
    private storage: StorageService,
    public gvs: GlobalVariablesService,
    public gms: GlobalMethodsService,
    public maintenanceService: MaintenanceService,
    private translate: TranslateConfigService,
    private defaultModalComponent: DefaultModalComponent,
    private navigation: NavigationService,
    public modalService: ModalService,
    public platform: Platform) { }

  async ngOnInit() {
    await this.gms.clearIntervalStatusInstallationEvent();
    this.user = this.gvs.user.userName;
    try {
      await this.getIncidences();
      await this.setLastMaintenanceInfo();
    } catch (e) {
      const message = JSON.stringify(e);
      await FirebaseCrashlytics.recordException({message: message});
     this.gms.setLoadingFalse();
    }
  }
  

  async ionViewDidEnter() {
    if(this.data != null && this.data != ''){
      await this.gms.setSetupPage(true, true, true, false);
    }
    this.gms.setLoadingFalse();
    this.gvs.modalLoaded = 'empty';
  }

  ionViewWillEnter(){
    this.gms.setLoadingTrue();
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Mantenimientos', contentGroup: 'Mantenimientos'}); 
  }

  async getIncidences() {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      let date = new Date();
      let actualDate = new Date();
      // this.failuresList = [];
      this.maintenancesList = [];
      this.requestParams = {
        user: this.user,
        s_ins: this.gvs.currentInstallation.s_ins,
        call_tp1: '%',
        call_tp2: '%',
        call_tp3: '%',
        call_tp4: '%',
        call_tp5: '%',
        nxt_maint_info: 'X',
        s_lang: '',
        limit: 20,
        limit_from: this.lastRowRequested
      };
      try{
        this.incidencesCompleteList = await this.maintenanceService.getIncidences(this.requestParams);
        if (this.incidencesCompleteList.length > 0){
          this.lastRowRequested = this.incidencesCompleteList[this.incidencesCompleteList.length - 1].row + 1;
        } else {
          if (this.failuresList.length > 0){
            this.allFailuresShown = true;
          }
        }
      }
      catch (e){
        const message = JSON.stringify(e);
        await FirebaseCrashlytics.recordException({message: message});
        this.modalCtrl.dismiss(false, '', 'maintenanceModal');
      }
      if (this.incidencesCompleteList != null) {
        this.incidencesCompleteList.forEach(incidence => {
          if (incidence.request_num === 0) {
            this.maintenancesList.push(incidence);
          }
          if (incidence.request_num !== 0) {
            this.failuresList.push(incidence);
          }
        })
        if (this.maintenancesList.length > 0){
          this.maintenancesList = this.maintenancesList.sort((a, b) => (Date.parse(a.sch_dt) > Date.parse(b.sch_dt)) ? 1 : ((Date.parse(b.sch_dt) > Date.parse(a.sch_dt)) ? -1 : 0));
          date.setTime(Date.parse(this.maintenancesList[this.maintenancesList.length - 1].sch_dt));
          date > actualDate ? this.isMaintenanceScheduled = true : this.isMaintenanceScheduled = false;
        }
        if (this.failuresList.length > 0){
          this.failuresList = this.failuresList.sort((a, b) => (Date.parse(a.crdt) > Date.parse(b.crdt)) ? -1 : ((Date.parse(b.crdt) > Date.parse(a.crdt)) ? 1 : 0));
        }
      }
      else {
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.notFoundMaintenanceData'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
    } else {
      this.modalCtrl.dismiss(false, '', 'loadSpinner');
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async setLastMaintenanceInfo() {
    if (this.maintenancesList.length > 0) {
      let date = new Date();
      date.setTime(Date.parse(this.maintenancesList[this.maintenancesList.length - 1].sch_dt));
      let hour: string;
      let minutes: string;
      this.lastMaintenanceDate = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
      date.getHours() < 10 ? hour = '0' + date.getHours() : hour = '' + date.getHours();
      date.getMinutes() < 10 ? minutes = '0' + date.getMinutes() : minutes = '' + date.getMinutes();
      this.lastMaintenanceHour = hour + ':' + minutes;
    }
  }

  async showIncidence(failure) {
    if (this.isServiceBusy) {
      return;
    }
    this.isServiceBusy = true;
    this.modalService.hide('maintenanceModal');
    const contentModal = await this.modalCtrl.create({
      component: IncidenceDetailComponent,
      componentProps: {
        failure
      },
      cssClass: ['modal-incidence']
    });
    contentModal.present().then();

    contentModal.onDidDismiss().then(async data => {
      this.gms.openMaintenanceModal(null);
     });
    this.isServiceBusy = false;
  }

  dismiss(value) {
    this.modalService.hide('maintenanceModal', value)
  }

  // Report failure button
  async reportFailure() {
    if (this.isServiceBusy) {
      return;
    }
    this.isServiceBusy = true;
    this.reportFailureBtn = true;

    // open modal
    const contentModal = await this.modalCtrl.create({
      component: ReportFailureComponent,
      id: "reportFailureModal",
      componentProps: {},
      cssClass: ['w-modal-md', 'report-modal']
    });

    contentModal.onDidDismiss().then(async data => {
      if (data.data === null){
        return;
      }
      this.zone.run(async () => {
        this.gms.loading();
        this.reportFailureBtn = false;
        try {
          this.lastRowRequested = 0;
          this.allFailuresShown = false;
          await this.getIncidences();
          await this.setLastMaintenanceInfo();
        } catch (e) {
          const message = JSON.stringify(e);
          await FirebaseCrashlytics.recordException({message: message});
         this.modalCtrl.dismiss(false, '', 'loadSpinner');
        }
       this.modalCtrl.dismiss(false, '', 'loadSpinner');
      });
    });

    contentModal.present().then();
    this.isServiceBusy = false;
  }

  async downloadFailureReport(failure: Incidence) {
    let base64Incidence = await this.maintenanceService.gAppuserSvrqViewDownload(this.user, failure.request_num);
    if (base64Incidence === undefined) {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.downloadReportKo'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      return;
    }
    this.gms.analyticsTrackEvent('failure_action', { eventCategory: 'SICOR/Descarga Incidencia', eventAction: 'Accion/Descarga Incidencia Inicio', eventLabel: failure.request_num });
    let contentType = 'application/pdf';
    let format = '.pdf';
    let base64Data = base64Incidence;
    FileSharer.share({
      filename: 'ReporteIncidenciaSICOR-' + failure.request_num + format,
      base64Data,
      contentType
    })
  }

  async logScrolling($event) {
    if (this.scrollDepthTriggered) {
      return;
    }
    const scrollHeight = $event.target.scrollHeight - $event.target.clientHeight;
    const currentScrollDepth = $event.target.scrollTop;
    const targetPercent = 99.91;
    const triggerDepth = ((scrollHeight / 100) * targetPercent);
    if (currentScrollDepth > triggerDepth && !this.allFailuresShown) {
      this.gms.setLoadingTrue();
      try{
        this.scrollDepthTriggered = true;
        await this.getIncidences();
        this.scrollDepthTriggered = false;
        this.gms.setLoadingFalse();
      }
      catch{
        this.gms.setLoadingFalse();
      }
    }
  }

}
